import { render, staticRenderFns } from "./TheoryTask.vue?vue&type=template&id=3d9141fc&scoped=true&"
import script from "./TheoryTask.vue?vue&type=script&lang=js&"
export * from "./TheoryTask.vue?vue&type=script&lang=js&"
import style0 from "./TheoryTask.vue?vue&type=style&index=0&id=3d9141fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9141fc",
  null
  
)

export default component.exports